import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import NotFound from './NotFound';
import { publicContentContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PublicRoutes = function PublicRoutes() {
  return ___EmotionJSX("section", {
    css: publicContentContainer
  }, ___EmotionJSX(Switch, null, ___EmotionJSX(Route, {
    exact: true,
    path: "/login",
    component: Login
  }), ___EmotionJSX(Route, {
    exact: true,
    path: "/forgot-password",
    component: ForgotPassword
  }), ___EmotionJSX(Redirect, {
    exact: true,
    from: "/",
    to: "/login"
  }), ___EmotionJSX(Route, {
    component: NotFound
  })));
};